import { esusApi } from "@/services/api";
import { DentalAttendanceProcedure } from "@/@types/esus/DentalAttendanceProcedure";

export type DetailedCitizenProceduresIndicatorB5Params = {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	ine?: string;
	citizenId: number;
};

export class DetailedCitizenProceduresIndicatorB5 {
	id: number = 0;
	cpf?: string;
	cns?: string;
	birthdate: string = "";
	fullName: string = "";
	area?: string;
	motherName?: string;
	gender?: number;
	street?: string;
	houseNumber?: string;
	neighborhood?: string;
	phone?: string;
	healthTeamId: number = 0;
	healthTeamIne: string = "";
	healthTeamName: string = "";
	dentalAttendanceProcedures?: DentalAttendanceProcedure[];
}

export async function getDetailedCitizenProcedureIndicatorB5({
	uf,
	ibgeCode,
	...params
}: DetailedCitizenProceduresIndicatorB5Params) {
	const response = await esusApi.get<DetailedCitizenProceduresIndicatorB5>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esb/b5/detailed-citizen-procedures`,
		params
	);
	return response.data ?? new DetailedCitizenProceduresIndicatorB5();
}
